import { render, staticRenderFns } from "./MyDocumentsTable.vue?vue&type=template&id=e106631e"
import script from "./MyDocumentsTable.vue?vue&type=script&lang=ts"
export * from "./MyDocumentsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports